<template>
  <section class="success">
    <img src="https://cdn.gelonghui.com/webActive/img_content_success.png" alt="">
    <button @click="beMember">
      <img src="https://cdn.gelonghui.com/webActive/img_button_download.png" alt="">立即下载
    </button>
  </section>
</template>

<script>
  // import axios from "axios"
  export default {
    name: "rule",
    data() {
      return {
        val: ""
      };
    },
    created() {

    },
    mounted() {
      document.title = '领取成功'
    },
    methods: {
      beMember() {
        window.location.href =
          "https://www.gelonghui.com/app/device_redirect.html";
      }
    }
  };

</script>
<style lang="less" scoped>
  * {
    margin: 0;
    padding: 0;
    list-style: none;
    text-decoration: none;
    box-sizing: border-box;
  }

  .success {
    position: relative;
    padding-bottom: 100px;
    max-width: 750px;
    width: 100%;
    margin: 0 auto;
    text-align: center;

    img {
      width: 100%;
    }

    >button {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 88px;
      border: none;
      outline: none;
      text-align: center;
      background: linear-gradient(90deg, rgba(255, 224, 170, 1) 0%, rgba(255, 224, 170, 1) 100%);
      font-size: 30px;
      font-weight: 600;
      color: rgba(120, 72, 47, 1);
      line-height: 88px;

      img {
        width: 40px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/member-share/success.vue